var React = require('react');

function Storage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21,0H55V34h0L44,45H10V11h.05L21,.05ZM12,13V43H22V36H32v7H42V13H32v7H22V13Zm32-.25,9-9V33.18l-9,9V12.75ZM42,11h.92l9-9H42.14l-9,9ZM34.14,2h5.17l-9,9H25.14ZM21.88,2h9.43l-9,9H12.88ZM24,13v5h6V13ZM0,11H6v2H4V43H6v2H0V43H2V13H0ZM44,49v6H42V53H12v2H10V49h2v2H42V49Zm4-3h6V44H52.73l8-8H62V34H57v2h.9L50,43.9l.1.1H48ZM30,43V38H24v5Zm10-4H34v2h6ZM14,26H24v2H14Zm6-4H14v2h6Zm4,0H22v2h2Zm13,8.39,0,0,3.54,3.53L39.12,35.3,38,34.17V37H36V34.17l-1.16,1.16-1.41-1.41L37,30.38Z","fillRule":"evenodd"}));
}

Storage.defaultProps = {"viewBox":"0 0 62 55"};

module.exports = Storage;

Storage.default = Storage;
